<template>
  <v-dialog
    v-model="getModalCadastroModeloTanque"
    scrollable
    persistent
    max-width="720px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>Cadastro de Modelo de Tanque</v-card-title>
      <v-card-text>
        <v-form class="px-3 mt-5">
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                v-model="getModeloTanque.modelo"
                label="Descrição"
                id="id"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-row justify="space-around" class="ml-3 mr-3 mb-3">
                <v-img
                  :src="$urlApp + '/produtos/sem_imagem.jpg'"
                  aspect-ratio="1.2"
                  contain
                  v-if="!getModeloTanque.foto_url"
                  max-width="300"
                ></v-img>
                <v-img
                  :src="getModeloTanque.foto_url"
                  aspect-ratio="1.2"
                  contain
                  v-if="getModeloTanque.foto_url"
                  max-width="300"
                ></v-img>
              </v-row>
            </v-flex>
            <v-flex xs12 md12>
              <v-file-input
                label="Anexo"
                v-if="showFieldFoto"
                @change="selecionaFoto"
                outlined
                dense
              ></v-file-input>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          outlined
          @click="setModalCadastroModeloTanque(false)"
          :loading="$store.getters.getOverlay"
          >Voltar</v-btn
        >
        <v-btn color="error" @click="setModalExcluirModeloTanque(true)" outlined
          >Excluir</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          outlined
          @click="salvar()"
          :loading="$store.getters.getOverlay"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
    <ModalExcluir />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalExcluir from "@/pages/modeloTanque/ModalExcluir";

export default {
  components: {
    ModalExcluir,
  },
  data() {
    return {
      showFieldFoto: true,
      foto: "",
    };
  },
  computed: {
    ...mapGetters(["getModalCadastroModeloTanque", "getModeloTanque"]),
  },
  methods: {
    ...mapActions([
      "setModalCadastroModeloTanque",
      "setModalExcluirModeloTanque",
      "salvarModeloTanque",
      "atualizarModeloTanque",
    ]),
    salvar() {
      const form = new FormData();

      if (this.getModeloTanque.modelo) {
        form.append("modelo", this.getModeloTanque.modelo);
      }

      if (this.foto) {
        console.log("foto", this.foto);
        form.append("foto", this.foto);
      }

      //   return;

      if (this.getModeloTanque.id) {
        form.append("_method", "PUT");
        form.append("id", this.getModeloTanque.id);
        this.atualizarModeloTanque(form);
      } else {
        this.salvarModeloTanque(form);
      }
    },
    selecionaFoto(e) {
      console.log(e);
      this.foto = e;
    },
  },
};
</script>